module.exports = __webpack_public_path__ + "img/rock-huge-11.fd630de2.png";